export const ANTHROPIC_BILLING_URL = 'https://console.anthropic.com/settings/billing';

export const styles = {
	banner: 'flex items-center gap-sm border-b border-red-100 bg-red-50 px-xl py-sm',
	title: 'text-[13px] font-semibold leading-tight text-red-800',
	description: 'mt-3xs text-[12px] leading-tight text-red-700',
	cta: 'inline-flex shrink-0 items-center gap-2xs rounded-md bg-red-700 px-sm py-2xs text-[12px] font-medium text-white hover:bg-red-800',
};
